import { clearSessionStorage, completeName, setLocalStorage, uppercaseInitials } from '../../utils';

export const setUserLogged = (payload: any) => {
  const userLogged = payload?.item?.userLogged;
  const data = userLogged
    ? {
        ...userLogged,
        completeName: completeName(userLogged.firstName, userLogged.middleName, userLogged.lastName),
        initialsName: uppercaseInitials(userLogged.firstName, userLogged.middleName, userLogged.lastName),
      }
    : null;

  setLocalStorage('userLogged', data);
  return data;
};

export const setUserSacInfo = (payload: any) => {
  const sacInfo = payload?.item?.sacInfo;
  setLocalStorage('sacInfo', sacInfo);
  return sacInfo;
};

export const setLogout = () => {
  clearSessionStorage();
  setLocalStorage('userLogged', null);
  setLocalStorage('sacInfo', null);
  return null;
};
